import { Injectable } from '@angular/core';

@Injectable({
    providedIn: "root"
})

export class StorageService {

    constructor() {

    }

    public getLocalStorage(name: string): any {
        return localStorage.getItem(name);
    }

    public setLocalStorage(name: string, value: any) {
        localStorage.setItem(name, value);
    }

    public removeLocalStorage(name: string): void {
        localStorage.removeItem(name);
    }

    public getSessionStorage(name: string): any {
        return sessionStorage.getItem(name);
    }

    public setSessionStorage(name: string, value: any) {
        sessionStorage.setItem(name, value);
    }

    public removeSessionStorage(name: string): void {
        sessionStorage.removeItem(name);
    }
}